<template>
  <SuccessButton data-dd="Bulk Edit: Add New Profile Button" @click="addEntry">
    + Add New Profile
  </SuccessButton>
</template>

<script setup>
import { useStore } from "vuex";
import SuccessButton from "@/components/CMSComponents/Buttons/SuccessButton.vue";

const props = defineProps({
  categoryID: {
    type: String,
    required: true,
  },
  gridApi: { type: [Object, null], default: null },
});

const store = useStore();

const scrollToTop = () => props.gridApi?.ensureIndexVisible(0);
const addEntry = async () => {
  const newEntryData = {
    categoryID: props.categoryID,
    layout: await store.dispatch("api/fetchMostCommonEntryLayout", {
      categoryID: props.categoryID,
    }),
  };

  await store.dispatch("api/addEntry", {
    doc: newEntryData,
    categoryID: props.categoryID,
  });
  scrollToTop();
};
</script>
